import React from 'react';

import {
  StyledMessage,
  StyledMessageButtons,
  StyledMessageButton
} from './style';
import Icon from '../../../core/Icon';
import { Trash, Pencil } from '../../../../../assets/images/index';

const StatusMessage = ({ text, onEdit, onDelete }) => (
  <StyledMessage>
    {text}
    <StyledMessageButtons>
      <StyledMessageButton transparent onClick={onDelete}>
        <Icon color="dark" size="m" svg={Trash} />
      </StyledMessageButton>
      <StyledMessageButton transparent onClick={onEdit}>
        <Icon color="dark" size="m" svg={Pencil} />
      </StyledMessageButton>
    </StyledMessageButtons>
  </StyledMessage>
);

export { StatusMessage };
